// extracted by mini-css-extract-plugin
module.exports = {"grey100":"#F2F2F7","mapContainer":"VetMap_mapContainer___2_2b","mapContainerWrapper":"VetMap_mapContainerWrapper__XXzIo"};